export const parseDecimal = (value: string | number) =>
  Number(String(value).trim().replace(',', '.').replace(/^\+/, ''));